import { render, staticRenderFns } from "./SelectBoxItem.vue?vue&type=template&id=29863756&scoped=true"
import script from "./SelectBoxItem.vue?vue&type=script&lang=ts"
export * from "./SelectBoxItem.vue?vue&type=script&lang=ts"
import style0 from "./SelectBoxItem.vue?vue&type=style&index=0&id=29863756&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29863756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29863756')) {
      api.createRecord('29863756', component.options)
    } else {
      api.reload('29863756', component.options)
    }
    module.hot.accept("./SelectBoxItem.vue?vue&type=template&id=29863756&scoped=true", function () {
      api.rerender('29863756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/SelectBoxItem.vue"
export default component.exports